import {
  DEFAULT_ORG_OUTCOME_SLUGS,
  isDefaultOrgOutcomeSlug,
} from "@/constants/orgOutcomes";
import type { OrgOutcomeDto } from "@/services/orgOutcomes";
import { formatOutcomeKeyLabel } from "@/utils/orgOutcomes/formatOutcomeKeyLabel";

export type ScriptOutcomeSource = "system" | "org";

export type ScriptOutcomeOption = {
  key: string;
  label: string;
  definition: string;
  source: ScriptOutcomeSource;
  searchText: string;
};

/**
 * Custom catalog entries only (system keys filtered out even if GET returns them).
 */
export function customOrgOutcomesFromCatalog(
  catalog: OrgOutcomeDto[] | null | undefined
): OrgOutcomeDto[] {
  if (!catalog?.length) return [];
  return catalog.filter(
    (o) => !o.isSystem && !isDefaultOrgOutcomeSlug(o.key)
  );
}

export function buildSystemScriptOutcomeOptions(
  translateDefinition: (slug: string) => string
): ScriptOutcomeOption[] {
  return DEFAULT_ORG_OUTCOME_SLUGS.map((key) => {
    const label = formatOutcomeKeyLabel(key);
    const definition = translateDefinition(key);
    return {
      key,
      label,
      definition,
      source: "system" as const,
      searchText: `${key} ${label} ${definition}`.toLowerCase(),
    };
  });
}

export function buildOrgScriptOutcomeOptions(
  customs: OrgOutcomeDto[]
): ScriptOutcomeOption[] {
  return customs.map((o) => {
    const label = formatOutcomeKeyLabel(o.key);
    return {
      key: o.key,
      label,
      definition: o.definition,
      source: "org" as const,
      searchText: `${o.key} ${label} ${o.definition}`.toLowerCase(),
    };
  });
}
